import { render, staticRenderFns } from "./NumberPauseModal.vue?vue&type=template&id=054b0f12"
import script from "./NumberPauseModal.vue?vue&type=script&lang=js"
export * from "./NumberPauseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports